export default {"src":"/_next/static/media/delivery-box.22429b8e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};